// 파일 경로: stores/useNetworkStore.ts

import { create } from "zustand";

// 스토어의 상태(state)와 액션(action)에 대한 타입을 정의합니다.
interface NetworkState {
  isOnline: boolean;
  setOnline: () => void;
  setOffline: () => void;
}

// create 함수를 사용하여 스토어를 생성합니다.
export const useNetworkStore = create<NetworkState>((set) => ({
  // 초기 상태값: 브라우저 환경이면 navigator.onLine 값을, 아니면 true를 기본값으로 설정
  isOnline: typeof window !== "undefined" ? window.navigator.onLine : true,

  // 액션 정의: set 함수를 사용하여 상태를 업데이트합니다.
  setOnline: () => {
    set({ isOnline: true });
  },
  setOffline: () => {
    set({ isOnline: false });
  },
}));
